export default "__VITE_ASSET__24901cb2__"